import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const getOrCreateSetupTracker = async <
  T extends Record<string, unknown>,
>({
  query,
  departmentId,
  instanceId,
  domain,
  headers,
}: FetchRequestArgs & {
  instanceId: string;
  departmentId: string;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: {
      department_id: departmentId,
      instance_id: instanceId,
    },
    domain,
    endpoint: `/v2/setup_trackers`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
